var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"container-fluid header-219 header-fixed header-default img-fluid",style:({
                backgroundColor: _vm.colorBg,
                backgroundImage: 'url(' + _vm.coverUrl + ')'
            })})])])}
var staticRenderFns = []

export { render, staticRenderFns }